export default "__VITE_ASSET__BRnBwvA0__"